import { render, staticRenderFns } from "./ProjectGrid.vue?vue&type=template&id=ebc62aee&"
import script from "./ProjectGrid.vue?vue&type=script&lang=js&"
export * from "./ProjectGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProjectGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports